module.exports = __webpack_public_path__ + "img/bg奖品@2x.a64ab633.png";